var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69672 5.94067C9.72949 5.90369 9.88275 5.78284 10.4846 5.78284L12.4579 5.7821C13.0999 5.7821 13.6219 5.25989 13.6219 4.61792V1.16895C13.6219 0.528076 13.1006 0.00585938 12.4598 0.00476072L9.52863 0C7.71954 0 6.18164 0.596741 5.08118 1.72595C3.98566 2.85004 3.40649 4.41925 3.40649 6.26367V8.12384H1.16418C0.522217 8.12384 0 8.64606 0 9.28802V13.0025C0 13.6445 0.522217 14.1667 1.16418 14.1667H3.40649V22.8358C3.40649 23.4778 3.92871 24 4.57068 24H8.41406C9.05603 24 9.57825 23.4778 9.57825 22.8358V14.1669H12.3192C12.9611 14.1669 13.4832 13.6445 13.4832 13.0029L13.4846 9.28821C13.4846 8.86652 13.2552 8.47632 12.8857 8.26996C12.7145 8.17438 12.5153 8.12384 12.3098 8.12384H9.57825V6.65424C9.57825 6.17523 9.6427 6.00183 9.69672 5.94067Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/FacebookLogo.70be546a56a4290c49ec1c06cbf91c85.svg";
export { ForwardRef as ReactComponent };